import {Box} from '@mui/material';
import React from 'react';
import ActionModal from './ActionModal';
import ContactAtrForm from '../AttitudeToRisk/ContactAtrForm';
import {ReviewDetailsFragment_contacts} from '../../schema-types/ReviewDetailsFragment';
import {useRTQ} from '../../hooks/useRTQ';

interface SendAtrQuestionnaireModalProps {
  contact: ReviewDetailsFragment_contacts;
  isOpen: boolean;
  close: () => void;
  accountId: string;
}

export const SendAtrQuestionnaireModal = ({
  contact,
  isOpen,
  close,
  accountId,
}: SendAtrQuestionnaireModalProps) => {
  const {atrName} = useRTQ();

  return (
    <ActionModal
      title={`${atrName.toLocaleUpperCase()} Scoring`}
      isOpen={isOpen}
      close={close}
      wide
      autoHeight
    >
      <ContactAtrForm
        atrName={atrName}
        contact={contact}
        close={close}
        accountId={accountId}
      />
      <Box mt={2} />
    </ActionModal>
  );
};

export default SendAtrQuestionnaireModal;
